document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".home-faq__item");

  if (!faqItems.length) {
    return;
  }

  faqItems.forEach((item) => {
    const questionButton = item.querySelector(".home-faq__item-question");
    const answerPanel = item.querySelector(".home-faq__item-answer");
    const icon = questionButton.querySelector(".home-faq__item-icon .fas");

    if (!questionButton || !answerPanel || !icon) {
      // console.warn("FAQ item missing essential elements:", item);
      return;
    }

    // Remove 'hidden' attribute to enable CSS transitions for max-height
    // The element will remain visually hidden due to max-height: 0 from CSS
    if (answerPanel.hasAttribute("hidden")) {
      answerPanel.removeAttribute("hidden");
    }

    questionButton.addEventListener("click", () => {
      const itemIsCurrentlyActive = item.classList.contains("active");

      // Close all other items
      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherQuestionButton = otherItem.querySelector(
            ".home-faq__item-question"
          );
          const otherAnswerPanel = otherItem.querySelector(
            ".home-faq__item-answer"
          );
          const otherIcon = otherQuestionButton.querySelector(
            ".home-faq__item-icon .fas"
          );

          if (otherItem.classList.contains("active")) {
            otherItem.classList.remove("active");
            if (otherQuestionButton) {
              otherQuestionButton.setAttribute("aria-expanded", "false");
            }
            if (otherIcon) {
              otherIcon.classList.remove("fa-minus");
              otherIcon.classList.add("fa-plus");
            }
            if (otherAnswerPanel) {
              otherAnswerPanel.style.maxHeight = null;
            }
          }
        }
      });

      // Toggle the clicked item
      if (itemIsCurrentlyActive) {
        // Closing the current item
        item.classList.remove("active");
        questionButton.setAttribute("aria-expanded", "false");
        icon.classList.remove("fa-minus");
        icon.classList.add("fa-plus");
        answerPanel.style.maxHeight = null;
      } else {
        // Opening the current item
        item.classList.add("active");
        questionButton.setAttribute("aria-expanded", "true");
        icon.classList.remove("fa-plus");
        icon.classList.add("fa-minus");
        answerPanel.style.maxHeight = answerPanel.scrollHeight + "px";
      }
    });
  });
});
